module.exports = __webpack_public_path__ + "static/img/img-gx.5d66534.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner/pc/img-gx.png
// module id = VTmn
// module chunks = 0